module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAWlBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8v///9AiNDf6/fK3vJHjdI2gs7m8PnR4vT1+f3U5PTG3PGzz+xUlNUC0Vb0AAAAEHRSTlMAVAb64Npb5KyJA/OrppSKdzdLMQAAAJBJREFUGNNtkFkOwyAMRI1ZQnZDCd3vf80KgxBNeD/WPGFpMDAoViVnvQqEitBU0KKoaaSGcWLJrrG8SycEAA5nOSAYumBgaVJ8f9OwoBr3ciFNBZLz8YkUH+7mU5AwswwueHZZ6vzy7p7s8vpCxVZHtlY6gq+VuuX73wTY/92eT7e1bpt6R66gsUpKZQ1y/AH6/BOBfAyU9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_save.png
// module id = B98s
// module chunks = 9